import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
  useTheme,
} from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import { withStyles } from "@material-ui/styles";
import { get } from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { selectMasterData } from "redux/modules/masterSlice";

const useStyles = makeStyles((theme) => ({
  box: {
    backgroundColor: theme.palette.primary.main,
  },
  wrapForm: {
    backgroundColor: "#39D5CF",
    padding: 70,
    borderRadius: 15,
    position: "relative",
  },
  wrapButton: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    justifyContent: "center",
  },
  buttonSearch: {
    width: 150,
  },
  search: {
    display: "flex",
    flexDirection: "row",
    height: 55,
    backgroundColor: "#ffffff",
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    // backgroundColor: fade(theme.palette.common.white, 0.15),
    // "&:hover": {
    //   backgroundColor: fade(theme.palette.common.white, 0.25),
    // },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
    zIndex: 1,
  },
  inputRoot: {
    // color: "#5f5f5f",
    overflow: "hidden",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(2)}px)`,
    paddingRight: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "20ch",
      "&:focus": {
        width: "30ch",
      },
    },
  },
  imgSearch: {
    width: 240,
    height: 240,
    cursor: "pointer",
    position: "absolute",
    bottom: -15,
    left: -15,
  },
  textField: {
    width: "100%",
    padding: "0px 15px",
  },
  noBorder: {
    border: "none",
  },
  formControl: {
    width: "100%",
    backgroundColor: "white",
    // padding: '0px 15px'
  },
  rootSelect: {
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      backgroundColor: "white",
      padding: "0px 5px",
      borderRadius: "6px",
    },
  },
}));

const styles = (theme) => ({
  // inputLabel: {
  //     "MuiInputLabel-shrink": {
  //         backgroundColor: "white", padding: "0px 5px", borderRadius: "6px"
  //     }
  // }
});

function sortByName(fileName) {
  return (a, b) => {
    const nameA = a[fileName]?.toUpperCase(); // ignore upper and lowercase
    const nameB = b[fileName]?.toUpperCase(); // ignore upper and lowercase

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // names must be equal
    return 0;
  };
}

function DocumentForm(props) {
  const theme = useTheme();
  const classes = useStyles();
  const [age, setAge] = React.useState("");
  const formik = props.formik;

  // const dispatch = useDispatch();
  // useEffect(() => {
  //     dispatch(
  //         getMasterData({
  //             smartservice: true,
  //             statusProcess: true
  //         })
  //     );
  // }, [dispatch]);

  const masterData = useSelector(selectMasterData);
  const statusProcess = get(masterData, "statusProcess", []);
  const smartservice = get(masterData, "smartservice", []);

  const resetForm = () => {
    formik.resetForm();
  };

  const isError = (fieldName) =>
    get(formik.touched, fieldName, "") &&
    Boolean(get(formik.errors, fieldName, ""));

  const getErrorMessage = (fieldName) =>
    get(formik.touched, fieldName, "")
      ? get(formik.errors, fieldName, "") || " "
      : " ";

  return (
    <form onSubmit={formik.handleSubmit} id="doc-search-form">
      <div className={classes.wrapForm}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            {/* <FormControl variant="outlined" className={classes.formControl}>
                            <InputLabel>Smart Service</InputLabel>
                            <Select
                                name="smartService"

                                value={formik.values.smartService}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}

                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {smartservice
                                    .map((v) => v)
                                    .sort(sortByName("smartserviceName"))
                                    .map((p) => (
                                        <MenuItem
                                            key={p.smartserviceId}
                                            value={p.smartserviceId}
                                        >
                                            {p.smartserviceName}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl> */}

            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel>Status Process</InputLabel>
              <Select
                name="statusProcess"
                className={classes.root}
                value={formik.values.statusProcess}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {statusProcess
                  .map((v) => v)
                  .sort(sortByName("statusName"))
                  .map((p) => (
                    <MenuItem key={p.statusProcessId} value={p.statusProcessId}>
                      {p.statusName}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl variant="outlined" className={classes.formControl}>
              {/* <InputLabel>Start Date</InputLabel> */}
              <DatePicker
                // style={{ width: 200 }}
                className={classes.formControl}
                inputVariant="outlined"
                openTo="year"
                format="DD-MM-YYYY"
                label="Start Date"
                views={["year", "month", "date"]}
                name={`startDate`}
                value={get(formik.values, `startDate`, null) || null}
                onChange={(date) => {
                  formik.setFieldValue(`startDate`, date.format("YYYY-MM-DD"));
                }}
                error={isError(`startDate`)}
                // helperText={getErrorMessage(`startDate`)}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControl variant="outlined" className={classes.formControl}>
              {/* <InputLabel>Start Date</InputLabel> */}
              <DatePicker
                // style={{ width: 200 }}
                className={classes.formControl}
                inputVariant="outlined"
                openTo="year"
                format="DD-MM-YYYY"
                label="End Date"
                views={["year", "month", "date"]}
                name={`endDate`}
                value={get(formik.values, `endDate`, null) || null}
                onChange={(date) => {
                  formik.setFieldValue(`endDate`, date.format("YYYY-MM-DD"));
                }}
                error={isError(`endDate`)}
                // helperText={getErrorMessage(`endDate`)}
              />
            </FormControl>
          </Grid>
          {/* <Grid item xs={12} md={4}>
                        <FormControl variant="outlined" className={classes.formControl}>
                            <InputLabel>Status Process</InputLabel>
                            <Select
                                name="statusProcess"

                                value={formik.values.statusProcess}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}

                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {statusProcess
                                    .map((v) => v)
                                    .sort(sortByName("statusName"))
                                    .map((p) => (
                                        <MenuItem
                                            key={p.statusProcessId}
                                            value={p.statusProcessId}
                                        >
                                            {p.statusName}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Grid> */}
          <Grid item xs={12}>
            <FormControl variant="outlined" className={classes.formControl}>
              <TextField
                variant="outlined"
                placeholder="Keyword Smart No, Firstname, Lastname"
                className={classes.textField}
                name="keyword"
                InputProps={{
                  classes: { notchedOutline: classes.noBorder },
                }}
                value={formik.values.keyword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("keyword")}
                // helperText={getErrorMessage("keyword")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.wrapButton}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                style={{ backgroundColor: "#1BA7A1" }}
                className={classes.buttonSearch}
              >
                SEARCH
              </Button>
              <Button
                type="button"
                onClick={resetForm}
                variant="outlined"
                size="large"
                className={classes.buttonSearch}
                style={{ backgroundColor: "#fff", marginLeft: 10 }}
              >
                CLEAR
              </Button>
            </div>
          </Grid>
        </Grid>
        <img
          src={"/assets/images/icon_search.png"}
          alt="icon-search"
          className={classes.imgSearch}
        />
      </div>
    </form>
  );
}

export default withStyles(styles)(DocumentForm);
